<template src="./Meet.html"></template>

<script>
import ArrobaMedellinArrobitaNoData from "@/components/ArrobaMedellinArrobitaNoData/ArrobaMedellinArrobitaNoData";
import ArrobaMedellinLiveKitRoom from "@/components/ArrobaMedellinLiveKitRoom/ArrobaMedellinLiveKitRoom";
import configService from "@/configs/config";
import { db, firebase } from "@/plugins/firebase";
import networkingService from "@/services/Networking";
import networkingBreakoutService from "@/services/NetworkingBreakout";
import networkingUsersService from "@/services/NetworkingUsers";
import livekitService from "@/services/Livekit";
import livekitClient from "@/utils/livekitClient";
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import networkingUsersTeacherServices from "../../services/NetworkingUsersTeacher";
const surveyTeacherDb = db.collection("considerNetworkingTeacher");
const surveyRoomDb = db.collection("considerNetworking");
const gameTeacherDb = db.collection("evaluationNetworkingTeacher");
const gameRoomDb = db.collection("evaluationNetworking");

export default {
  name: "Meet",
  components: {
    ArrobaMedellinArrobitaNoData,
    ArrobaMedellinLiveKitRoom,
  },
  data() {
    return {
      role: "",
      livekitRoomName: "",
      livekitParticipantCount: 0,
      networking: {},
      showProfileText: "Ocultar lista de ingreso en sala",
      userInfo: {},
      getParticipantsInfo: [],
      isModerator: false,
      networkingUsers: [],
      followsRequest: [],
      intervalMeet: null,
      columnOne: "column is-8",
      columnTwo: "column is-4",
      // Estado de las columnas antes de plegarlas por pantalla compartida
      columnsBeforeShare: null,
      moderatorInfo: false,
      surveyTime: [
        { id: 60000, duration: "1 minuto" },
        { id: 120000, duration: "2 minutos" },
        { id: 180000, duration: "3 minutos" },
      ],
      gameTime: [
        { id: 60000, duration: "1 minuto" },
        { id: 120000, duration: "2 minutos" },
        { id: 180000, duration: "3 minutos" },
      ],
      sectionCreateSurvey: true,
      sectionSurveyresult: false,
      createQuestionsSection: true,
      sectionGameResult: false,
      surveyInfo: {
        question: "",
        answersOne: "",
        answersTwo: "",
        answersThree: "",
        answersFour: "",
        duration: 60000,
        responses: [],
        considerNetworkingTeacherId: null,
        considerNetworkingId: null,
      },
      gameInfo: {
        question: "",
        answersOne: "",
        answersTwo: "",
        answersThree: "",
        answersFour: "",
        duration: 60000,
        responses: [],
        evaluationNetworkingTeacherId: null,
        evaluationNetworkingId: null,
      },
      isPrivateRoom: false,
      modalIsPrivateRoom: true,
      copyMeetingUrl: "",
      modalSurveyResponses: false,
      modalGameResponses: false,
      surveyResponses: {},
      gameResponses: [],
      infoConsultPrivateRoom: {},
      isUrl: true,
      userAddedRoom: {
        networkingTeacher: { id: 0, aforo: 0 },
        user: {},
      },
      infoSurvey: {},
      infoGame: {},
      infoPrivateRoomSurveyResults: [
        { considerNetworkingTeacher: { answers: "" } },
      ],
      infoPrivateRoomGameResults: [
        { evaluationNetworkingTeacher: { answers: "" } },
      ],
      infoRoomSurveyResults: [{ considerNetworking: { answers: "" } }],
      infoRoomGameResults: [{ evaluationNetworking: { answers: "" } }],
      arrayResultSurvey: [{ votes: 0 }],
      arrayResultGame: [{ votes: 0 }],
      enableButton: false,
      activeTab: 1,
      timer: 0,
      minutes: 0,
      seconds: 0,
      timerGame: 0,
      minutesGame: 0,
      secondsGame: 0,
      sectionSurveyTime: false,
      sectionGameTime: false,
      isActive: "survey",
      correctAnswersOne: false,
      correctAnswersTwo: false,
      correctAnswersThree: false,
      correctAnswersFour: false,
      modalGameFeedback: false,
      arrayCorrectAnswers: [],
      // Firestore unsubscribe refs
      unsubscribeUsers: null,
      unsubscribeTeacherParticipants: null,
      unsubscribeSurvey: null,
      unsubscribeGame: null,
      // Livekit properties
      livekitUrl: configService.livekitUrl,
      livekitToken: "",
      livekitConnected: false,
      livekitError: null,
      // Breakout rooms (sub-salas)
      currentRoomName: "",
      currentRoomLabel: "",
      breakouts: [],
      breakoutMode: null,
      breakoutStatus: null,
      breakoutAssignments: [],
      myBreakout: null,
      breakoutPollInterval: null,
      breakoutForm: {
        rooms: 2,
        mode: "manual",
        aforo: null,
      },
      breakoutModeOptions: [
        {
          value: "manual",
          label: "Asignación manual",
          description: "Tú eliges quién va a cada sala.",
          icon: "fas fa-hand-pointer",
        },
        {
          value: "random",
          label: "Aleatoria automática",
          description: "Se reparten equitativamente al azar.",
          icon: "fas fa-random",
        },
        {
          value: "free",
          label: "Libre elección",
          description: "Cada quien elige su sala y puede cambiarse.",
          icon: "fas fa-door-open",
        },
      ],
      breakoutBroadcastMessage: "",
      openingBreakouts: false,
      closingBreakouts: false,
      assigningBreakoutUser: null,
      joiningBreakout: false,
    };
  },
  validations() {
    const infoSurvey = {
      surveyInfo: {
        question: { required },
        answersOne: { required },
        answersTwo: { required },
        duration: { required },
      },
    };
    const infoGame = {
      gameInfo: {
        question: { required },
        answersOne: { required },
        answersTwo: { required },
        duration: { required },
        activeStart: { required },
      },
    };
    if (this.isActive === "survey") {
      return infoSurvey;
    }
    if (this.isActive === "gameQuestion") {
      return infoGame;
    }
  },
  created() {
    this.role = this.$store.state.User.user.role.name;
  },
  async mounted() {
    this.copyMeetingUrl = window.location;
    this.isPrivateRoom = this.$route.params.isPrivateRoom || false;
    this.isUrl = this.$route.params.isUrl;
    if (this.isUrl === undefined) {
      this.isUrl = false;
    }

    try {
      await this.initRoom();
      this.initSurvey();
      this.initGame();
    } catch (error) {
      this.handleRoomError(error);
    }
  },
  methods: {
    async initRoom() {
      if (this.isPrivateRoom && this.isUrl) {
        await this.joinPrivateTeacherRoom();
      } else if (this.isUrl) {
        await this.joinViaSharedUrl();
      } else if (this.isPrivateRoom) {
        await this.joinPrivateRoom();
      } else {
        await this.joinPublicRoom();
      }
    },
    async joinPublicRoom() {
      this.networking = await networkingService.getNetworking(
        this.$route.params.idNetworking
      );
      const participant = {
        networkingId: this.$route.params.idNetworking,
      };
      const userParticipant =
        await networkingUsersService.userNetworkingParticipant(participant);
      if (!userParticipant.participant) {
        throw new Error("El participante no tiene acceso a esta sala");
      }
      this.$buefy.toast.open({
        duration: 3000,
        position: "is-bottom",
        message: "¡Ingresando a la sala!",
        type: "is-success",
      });
      this.validateModerador();
      await this.getNetworkigUsers();
      this.createdLiveKit(this.networking);
    },
    async joinPrivateRoom() {
      this.infoConsultPrivateRoom =
        await networkingService.consultPrivateRoom();
      this.modalIsPrivateRoom = false;
      this.validateModerador();
      await this.getNetworkigUsersTeachersForPrivate();
      this.createdLiveKit(this.infoConsultPrivateRoom.networkingTeacher);
    },
    async joinPrivateTeacherRoom() {
      this.infoConsultPrivateRoom =
        await networkingService.consultPrivateRoom();
      this.modalIsPrivateRoom = false;
      this.validateModerador();
      await this.getNetworkigUsersTeachersForPrivate();
      this.createdLiveKit(this.infoConsultPrivateRoom.networkingTeacher);
    },
    async joinViaSharedUrl() {
      this.userAddedRoom =
        await networkingUsersTeacherServices.createdNetworkingUsersTeacher({
          networkingId: Number(this.$route.params.idNetworking),
        });
      await this.subscribeToTeacherParticipants(
        this.userAddedRoom.networkingTeacher.id,
        this.userAddedRoom.networkingTeacher.aforo
      );
      this.$buefy.toast.open({
        duration: 3000,
        position: "is-bottom",
        message: "¡Ingresando a la sala con éxito!",
        type: "is-success",
      });
      this.createdLiveKit(this.userAddedRoom.networkingTeacher);
    },
    handleRoomError(error) {
      const backendMsg = error?.response?.data?.message || error?.message || "";
      let message = "Error al conectar con la sala";
      if (
        backendMsg.includes("No existe la sala") ||
        backendMsg.includes("not exist")
      ) {
        message = "La sala no existe o fue eliminada. Serás redirigido.";
      } else if (backendMsg.includes("no tiene acceso")) {
        message = "No tienes acceso a esta sala.";
      } else if (backendMsg.includes("llena") || backendMsg.includes("full")) {
        message = "La sala está llena. Intenta más tarde.";
      }
      this.$buefy.toast.open({
        duration: 5000,
        position: "is-bottom",
        message,
        type: "is-danger",
      });
      setTimeout(() => {
        this.$router.push({ name: "Networking" });
      }, 3000);
    },
    async getNetworkigUsers() {
      const { id } = this.networking;
      this.unsubscribeUsers = networkingUsersService
        .getNetworkingUsers(id)
        .onSnapshot((snapshot) => {
          snapshot.docChanges().forEach((change) => {
            if (change.type === "added") {
              this.networkingUsers.push({
                ...change.doc.data(),
                id: change.doc.id,
              });
            }
            if (change.type === "removed") {
              this.networkingUsers = this.networkingUsers.filter(
                (user) => user.id !== change.doc.id
              );
              this.$router.push({ name: "Networking" });
            }
          });
        });
    },
    subscribeToTeacherParticipants(networkingTeacherId, aforo) {
      this.unsubscribeTeacherParticipants = networkingUsersTeacherServices
        .getNetworkingUsersTeacher(networkingTeacherId, aforo)
        .onSnapshot((snapshot) => {
          snapshot.docChanges().forEach((change) => {
            if (change.type === "added") {
              this.networkingUsers.push({
                ...change.doc.data(),
                id: change.doc.id,
              });
            }
            if (change.type === "removed") {
              this.networkingUsers = this.networkingUsers.filter(
                (user) => user.id !== change.doc.id
              );
            }
          });
        });
    },
    async getNetworkigUsersTeachersForPrivate() {
      const { id, aforo } = this.infoConsultPrivateRoom.networkingTeacher;
      this.subscribeToTeacherParticipants(id, aforo);
    },
    /** ¿Ese userId es el moderador (creador) de la sala? */
    isRoomModerator(userId) {
      const moderatorId = this.isPrivateRoom
        ? this.infoConsultPrivateRoom?.networkingTeacher?.moderator?.id
        : this.networking?.userId;
      if (!moderatorId) return false;
      return String(moderatorId) === String(userId);
    },
    validateModerador() {
      if (this.isPrivateRoom) {
        if (
          this.infoConsultPrivateRoom.networkingTeacher.moderator.id ===
          this.user.id
        ) {
          this.isModerator = true;
        }
      } else if (this.user.id == this.networking.userId) {
        this.isModerator = true;
        this.moderatorInfo = true;
      }
    },
    createdLiveKit(networking) {
      this.livekitRoomName = networking.meetUrl;
      this.currentRoomName = networking.meetUrl;
      if (this.networkingMode) {
        this.initBreakouts();
      }
    },
    // ============================================================
    // Breakout rooms (sub-salas estilo Zoom)
    // ============================================================
    async initBreakouts() {
      await this.loadBreakouts({ initial: true });
      this.breakoutPollInterval = setInterval(() => {
        this.loadBreakouts({ silent: true });
      }, 5000);
    },
    async loadBreakouts({ initial = false, silent = false } = {}) {
      if (!this.networking.id) return;
      try {
        const state = await networkingBreakoutService.getBreakouts(
          this.networking.id,
          { silent }
        );
        this.breakouts = state.breakouts || [];
        this.breakoutMode = state.mode;
        this.breakoutStatus = state.status;
        this.breakoutAssignments = state.assignments || [];
        this.myBreakout = state.myAssignment;

        // Auto-corrección: la asignación en BD es la fuente de verdad.
        // El moderador se excluye (puede visitar salas libremente).
        if (!this.isModerator) {
          const expectedRoom = this.myBreakout
            ? this.myBreakout.roomName
            : this.livekitRoomName;
          if (expectedRoom && this.currentRoomName !== expectedRoom) {
            this.switchToRoom(expectedRoom);
          }
        } else if (initial && this.currentRoomName !== this.livekitRoomName) {
          // El moderador siempre reingresa por la principal tras recargar
          this.switchToRoom(this.livekitRoomName);
        }
      } catch (error) {
        if (!silent) console.error("Error loading breakouts:", error);
      }
    },
    breakoutLabelFor(roomName) {
      const breakout = this.breakouts.find((b) => b.roomName === roomName);
      return breakout ? breakout.name : "";
    },
    breakoutIdFor(userId) {
      const assignment = this.breakoutAssignments.find(
        (a) => String(a.userId) === String(userId)
      );
      return assignment ? assignment.breakoutId : null;
    },
    myBreakoutNameFor(userId) {
      const breakoutId = this.breakoutIdFor(userId);
      if (!breakoutId) return "";
      const breakout = this.breakouts.find((b) => b.id === breakoutId);
      return breakout ? breakout.name : "";
    },
    switchToRoom(roomName) {
      this.currentRoomLabel =
        roomName === this.livekitRoomName ? "" : this.breakoutLabelFor(roomName);
      this.currentRoomName = roomName;
    },
    handleBreakoutSignal(message) {
      if (message.type === "breakout:move" && message.targetRoom) {
        this.switchToRoom(message.targetRoom);
        this.$buefy.toast.open({
          duration: 4000,
          position: "is-bottom",
          message: `Te movieron a ${
            this.breakoutLabelFor(message.targetRoom) || "una sub-sala"
          }`,
          type: "is-info",
        });
      } else if (message.type === "breakout:return") {
        this.switchToRoom(this.livekitRoomName);
      }
    },
    async openBreakoutRooms() {
      if (this.openingBreakouts) return;
      this.openingBreakouts = true;
      try {
        const payload = {
          networkingId: this.networking.id,
          mode: this.breakoutForm.mode,
          rooms: Number(this.breakoutForm.rooms),
        };
        if (this.breakoutForm.mode === "free" && this.breakoutForm.aforo) {
          payload.aforo = Number(this.breakoutForm.aforo);
        }
        const result = await networkingBreakoutService.openBreakouts(payload);
        this.breakouts = result.breakouts || [];
        this.breakoutMode = this.breakoutForm.mode;
        this.breakoutStatus = "open";

        // Modo aleatorio: mover ya a los asignados vía DataChannel
        if (
          this.breakoutForm.mode === "random" &&
          result.assignments &&
          result.assignments.length
        ) {
          await livekitService.moveToBreakout({
            mainRoom: this.livekitRoomName,
            moves: result.assignments.map((a) => ({
              userId: String(a.userId),
              targetRoom: a.roomName,
            })),
          });
        }
        this.$buefy.toast.open({
          duration: 4000,
          position: "is-bottom",
          message: `Se abrieron ${this.breakouts.length} sub-salas`,
          type: "is-success",
        });
        await this.loadBreakouts({ silent: true });
      } catch (error) {
        console.error("Error opening breakouts:", error);
        this.$buefy.toast.open({
          duration: 5000,
          position: "is-bottom",
          message:
            error?.response?.data?.message || "Error al abrir las sub-salas",
          type: "is-danger",
        });
      } finally {
        this.openingBreakouts = false;
      }
    },
    async assignUserToBreakout(networkingUser, breakoutId) {
      const userId = String(networkingUser.userId);
      this.assigningBreakoutUser = userId;
      try {
        const results = await networkingBreakoutService.assignBreakouts({
          networkingId: this.networking.id,
          assignments: [{ userId, breakoutId }],
        });
        const assignment = results && results[0];
        if (assignment && assignment.roomName) {
          await livekitService.moveToBreakout({
            mainRoom: this.livekitRoomName,
            moves: [{ userId, targetRoom: assignment.roomName }],
          });
        } else {
          await livekitService.returnFromBreakout({
            mainRoom: this.livekitRoomName,
            userIds: [userId],
          });
        }
        await this.loadBreakouts({ silent: true });
      } catch (error) {
        console.error("Error assigning breakout:", error);
        this.$buefy.toast.open({
          duration: 4000,
          position: "is-bottom",
          message: "Error al asignar el participante",
          type: "is-danger",
        });
      } finally {
        this.assigningBreakoutUser = null;
      }
    },
    async joinBreakoutAsParticipant(breakout) {
      if (this.joiningBreakout) return;
      this.joiningBreakout = true;
      try {
        await networkingBreakoutService.joinBreakout({
          networkingId: this.networking.id,
          breakoutId: breakout.id,
        });
        this.switchToRoom(breakout.roomName);
        await this.loadBreakouts({ silent: true });
      } catch (error) {
        console.error("Error joining breakout:", error);
        this.$buefy.toast.open({
          duration: 4000,
          position: "is-bottom",
          message:
            error?.response?.data?.message || "No fue posible unirte a la sub-sala",
          type: "is-danger",
        });
      } finally {
        this.joiningBreakout = false;
      }
    },
    async returnToMainRoom() {
      try {
        if (!this.isModerator && this.breakoutMode === "free") {
          await networkingBreakoutService.joinBreakout({
            networkingId: this.networking.id,
            breakoutId: null,
          });
        }
      } catch (error) {
        console.error("Error clearing breakout assignment:", error);
      }
      this.switchToRoom(this.livekitRoomName);
      this.loadBreakouts({ silent: true });
    },
    visitBreakout(breakout) {
      // El moderador entra con permisos completos, sin persistir asignación
      this.switchToRoom(breakout.roomName);
    },
    async sendBroadcastMessage() {
      const message = this.breakoutBroadcastMessage.trim();
      if (!message) return;
      try {
        await livekitService.broadcastToBreakouts({
          mainRoom: this.livekitRoomName,
          message,
        });
        this.breakoutBroadcastMessage = "";
        this.$buefy.toast.open({
          duration: 3000,
          position: "is-bottom",
          message: "Mensaje enviado a todas las salas",
          type: "is-success",
        });
      } catch (error) {
        console.error("Error broadcasting:", error);
        this.$buefy.toast.open({
          duration: 4000,
          position: "is-bottom",
          message: "Error al enviar el mensaje",
          type: "is-danger",
        });
      }
    },
    closeBreakoutRooms() {
      this.$buefy.dialog.confirm({
        title: "Cerrar sub-salas",
        message:
          "Los participantes verán un aviso de 30 segundos y volverán a la sala principal. ¿Continuar?",
        confirmText: "Cerrar sub-salas",
        cancelText: "Cancelar",
        type: "is-warning",
        hasIcon: true,
        onConfirm: async () => {
          this.closingBreakouts = true;
          try {
            await livekitService.closeBreakoutRooms({
              mainRoom: this.livekitRoomName,
              seconds: 30,
            });
            await networkingBreakoutService.closeBreakouts({
              networkingId: this.networking.id,
            });
            this.$buefy.toast.open({
              duration: 4000,
              position: "is-bottom",
              message: "Sub-salas cerrándose. Countdown de 30s iniciado.",
              type: "is-success",
            });
            await this.loadBreakouts({ silent: true });
          } catch (error) {
            console.error("Error closing breakouts:", error);
            this.$buefy.toast.open({
              duration: 4000,
              position: "is-bottom",
              message: "Error al cerrar las sub-salas",
              type: "is-danger",
            });
          } finally {
            this.closingBreakouts = false;
          }
        },
      });
    },
    onKicked() {
      setTimeout(() => {
        this.$router.push({ name: "Networking" });
      }, 2000);
    },
    /**
     * Actualiza "Personas en sala" del distrito con las personas conectadas en
     * todo el networking (principal + sub-salas), no solo en la sala donde está
     * este cliente. Es informativo: el cupo lo aplica gestor-api.
     */
    async changeNumberParticipants() {
      if (!this.networkingMode || !this.networking.id) return;
      try {
        const { count } = await livekitService.networkingOccupancy(
          this.livekitRoomName,
          { silent: true }
        );
        if (count === this.networking.person) return;
        await networkingService.updateConnectedPeople(
          { id: this.networking.id, person: count },
          { silent: true }
        );
        this.networking = { ...this.networking, person: count };
      } catch (error) {
        console.warn("No se pudo actualizar el conteo de la sala", error);
      }
    },
    onRoomFull(detail) {
      if (this.breakoutPollInterval) clearInterval(this.breakoutPollInterval);
      this.$buefy.toast.open({
        duration: 6000,
        position: "is-bottom",
        message:
          detail?.message ||
          "La sala está llena. Intenta más tarde o elige otra sala.",
        type: "is-warning",
      });
      setTimeout(() => {
        this.$router.push({ name: "Networking" });
      }, 3000);
    },
    stepRooms(delta) {
      const next = Number(this.breakoutForm.rooms) + delta;
      this.breakoutForm.rooms = Math.min(20, Math.max(1, next));
    },
    stepAforo(delta) {
      const current = Number(this.breakoutForm.aforo) || 0;
      const next = current === 0 && delta > 0 ? 2 : current + delta;
      this.breakoutForm.aforo = next < 2 ? null : Math.min(50, next);
    },
    confirmFinishEvent() {
      this.$buefy.dialog.confirm({
        title: "Finalizar la sala",
        message:
          "La sala se cerrará para <b>todos los participantes</b>. ¿Seguro que quieres finalizarla?",
        confirmText: "Finalizar sala",
        cancelText: "Cancelar",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => this.finishEvent(),
      });
    },
    /**
     * Con pantalla compartida el asistente ve solo la presentación: el panel
     * lateral le robaba ancho y en móvil dejaba la diapositiva ilegible.
     * Al dejar de compartir se restaura lo que el usuario tenía antes, para
     * no deshacerle un "Ocultar lista" que hubiera elegido él mismo.
     */
    onScreenShareChanged(sharing) {
      if (this.isModerator) return;
      if (sharing) {
        if (this.columnsBeforeShare === null) {
          this.columnsBeforeShare = {
            one: this.columnOne,
            two: this.columnTwo,
            label: this.showProfileText,
          };
        }
        this.columnOne = "column is-12";
        this.columnTwo = "is-hidden";
        return;
      }
      if (this.columnsBeforeShare) {
        this.columnOne = this.columnsBeforeShare.one;
        this.columnTwo = this.columnsBeforeShare.two;
        this.showProfileText = this.columnsBeforeShare.label;
        this.columnsBeforeShare = null;
      }
    },
    buttonShowProfiles(showProfileText) {
      if (showProfileText === "Ocultar lista de ingreso en sala") {
        this.columnOne = "column is-12";
        this.columnTwo = "column is-0";
        this.showProfileText = "Mostrar lista de ingreso en sala";
      } else if (showProfileText === "Mostrar lista de ingreso en sala") {
        this.columnOne = "column is-8";
        this.columnTwo = "column is-4";
        this.showProfileText = "Ocultar lista de ingreso en sala";
      }
    },
    async finishEvent() {
      try {
        await livekitClient.disconnectFromRoom();
        const result = await networkingUsersService.deleteNetworkingUsers(
          this.networking.id
        );
        if (result) {
          clearInterval(this.intervalMeet);
          this.$router.push({ name: "Networking" });
        }
      } catch (error) {
        console.error("Error finishing event:", error);
      }
    },
    async StartSurvey() {
      try {
        const answers = [];
        if (this.surveyInfo.answersOne) {
          answers.push({
            option: this.surveyInfo.answersOne,
          });
        }
        if (this.surveyInfo.answersTwo) {
          answers.push({
            option: this.surveyInfo.answersTwo,
          });
        }
        if (this.surveyInfo.answersThree) {
          answers.push({
            option: this.surveyInfo.answersThree,
          });
        }
        if (this.surveyInfo.answersFour) {
          answers.push({
            option: this.surveyInfo.answersFour,
          });
        }
        if (!this.isPrivateRoom) {
          const obj = {
            question: this.surveyInfo.question,
            answers: answers,
            duration: this.surveyInfo.duration,
            networkingId: this.$route.params.idNetworking,
          };
          this.infoSurvey = await networkingService.createRoomSurvey(obj);
        } else {
          const objTeacher = {
            question: this.surveyInfo.question,
            answers: answers,
            duration: this.surveyInfo.duration,
            networkingTeacherId:
              this.infoConsultPrivateRoom.networkingTeacher.id,
          };
          this.infoSurvey = await networkingService.createSurveyTeacher(
            objTeacher
          );
        }
        this.sectionSurveyTime = true;
        this.sectionCreateSurvey = false;
      } catch (error) {
        console.error("error", error);
      }
    },
    startNewSurvey() {
      this.sectionSurveyTime = false;
      this.sectionSurveyresult = false;
      this.sectionCreateSurvey = true;
      this.surveyInfo = {
        question: "",
        answersOne: "",
        answersTwo: "",
        answersThree: "",
        answersFour: "",
        duration: 60000,
        responses: [],
        considerNetworkingTeacherId: null,
        considerNetworkingId: null,
      };
      this.arrayResultSurvey = [{ votes: 0 }];
      this.enableButton = false;
      this.surveyResponses = {};
    },
    startNewGame() {
      this.sectionGameTime = false;
      this.sectionGameResult = false;
      this.createQuestionsSection = true;
      this.gameInfo = {
        question: "",
        answersOne: "",
        answersTwo: "",
        answersThree: "",
        answersFour: "",
        duration: 60000,
        responses: [],
        evaluationNetworkingTeacherId: null,
        evaluationNetworkingId: null,
      };
      this.arrayResultGame = [{ votes: 0 }];
      this.gameResponses = [];
      this.enableButton = false;
      this.correctAnswersOne = false;
      this.correctAnswersTwo = false;
      this.correctAnswersThree = false;
      this.correctAnswersFour = false;
    },
    async StartGame() {
      try {
        const answersGame = [];
        if (this.gameInfo.answersOne) {
          answersGame.push({
            option: this.gameInfo.answersOne,
            correct: this.correctAnswersOne,
          });
        }
        if (this.gameInfo.answersTwo) {
          answersGame.push({
            option: this.gameInfo.answersTwo,
            correct: this.correctAnswersTwo,
          });
        }
        if (this.gameInfo.answersThree) {
          answersGame.push({
            option: this.gameInfo.answersThree,
            correct: this.correctAnswersThree,
          });
        }
        if (this.gameInfo.answersFour) {
          answersGame.push({
            option: this.gameInfo.answersFour,
            correct: this.correctAnswersFour,
          });
        }
        if (!this.isPrivateRoom) {
          const obj = {
            question: this.gameInfo.question,
            answers: answersGame,
            duration: this.gameInfo.duration,
            networkingId: this.$route.params.idNetworking,
          };
          this.infoGame = await networkingService.createRoomGame(obj);
        } else {
          const objTeacher = {
            question: this.gameInfo.question,
            answers: answersGame,
            duration: this.gameInfo.duration,
            networkingTeacherId:
              this.infoConsultPrivateRoom.networkingTeacher.id,
          };
          this.infoGame = await networkingService.createRoomGameTeacher(
            objTeacher
          );
        }
        this.sectionGameTime = true;
        this.createQuestionsSection = false;
      } catch (error) {
        console.error("error", error);
      }
    },
    infoPrivateRoom() {
      this.modalIsPrivateRoom = false;
    },
    copyUrl(url) {
      try {
        navigator.clipboard.writeText(url);
        this.$buefy.toast.open({
          duration: 5000,
          position: "is-bottom",
          message: "Se copió la URL correctamente",
          type: "is-success",
        });
      } catch (err) {
        console.log(err);
        this.$swal({
          text: err.message || "Ocurrio un error, intenta mas tarde.",
          buttons: false,
          icon: "error",
          timer: 3000,
        });
      }
    },
    async initSurvey() {
      const dateEnter = firebase.firestore.Timestamp.now();
      if (this.isPrivateRoom || this.isUrl) {
        this.unsubscribeSurvey = surveyTeacherDb
          .where(
            "networkingTeacherId",
            "==",
            Number(this.$route.params.idNetworking)
          )
          .where("createdSurvey", ">=", dateEnter)
          .onSnapshot((snapshot) => {
            snapshot.docChanges().forEach((change) => {
              switch (change.type) {
                case "added":
                  if (!this.isModerator) {
                    this.modalSurveyResponses = true;
                  }
                  this.surveyInfo = change.doc.data();
                  setTimeout(() => {
                    this.modalSurveyResponses = false;
                    this.enableButton = true;
                    this.privateRoomSurveyResults(
                      this.surveyInfo.considerNetworkingTeacherId
                    );
                  }, this.surveyInfo.duration);
                  this.countDownTimer();
                  break;
              }
            });
          });
      } else {
        this.unsubscribeSurvey = surveyRoomDb
          .where("networkingId", "==", Number(this.$route.params.idNetworking))
          .where("createdSurvey", ">=", dateEnter)
          .onSnapshot((snapshot) => {
            snapshot.docChanges().forEach((change) => {
              switch (change.type) {
                case "added":
                  if (!this.isModerator) {
                    this.modalSurveyResponses = true;
                  }
                  this.surveyInfo = change.doc.data();
                  setTimeout(() => {
                    this.modalSurveyResponses = false;
                    this.enableButton = true;
                    this.roomSurveyResults(
                      this.surveyInfo.considerNetworkingId
                    );
                  }, this.surveyInfo.duration);
                  this.countDownTimer();
                  break;
              }
            });
          });
      }
    },
    async initGame() {
      const dateEnter = firebase.firestore.Timestamp.now();
      if (this.isPrivateRoom || this.isUrl) {
        this.unsubscribeGame = gameTeacherDb
          .where(
            "networkingTeacherId",
            "==",
            Number(this.$route.params.idNetworking)
          )
          .where("createdSurvey", ">=", dateEnter)
          .onSnapshot((snapshot) => {
            snapshot.docChanges().forEach((change) => {
              switch (change.type) {
                case "added":
                  if (!this.isModerator) {
                    this.modalGameResponses = true;
                  }
                  this.gameInfo = change.doc.data();
                  setTimeout(() => {
                    this.modalGameResponses = false;
                    this.createArrayFeedback();
                    if (!this.isModerator) {
                      this.modalGameFeedback = true;
                    }
                    this.enableButton = true;
                    this.privateRoomGameResults(
                      this.gameInfo.evaluationNetworkingTeacherId
                    );
                  }, this.gameInfo.duration);
                  this.countDownTimerGame();
                  break;
              }
            });
          });
      } else {
        this.unsubscribeGame = gameRoomDb
          .where("networkingId", "==", Number(this.$route.params.idNetworking))
          .where("createdSurvey", ">=", dateEnter)
          .onSnapshot((snapshot) => {
            snapshot.docChanges().forEach((change) => {
              switch (change.type) {
                case "added":
                  if (!this.isModerator) {
                    this.modalGameResponses = true;
                  }
                  this.gameInfo = change.doc.data();
                  setTimeout(() => {
                    this.modalGameResponses = false;
                    this.createArrayFeedback();
                    if (!this.isModerator) {
                      this.modalGameFeedback = true;
                    }
                    this.enableButton = true;
                    this.roomGameResults(this.gameInfo.evaluationNetworkingId);
                  }, this.gameInfo.duration);
                  this.countDownTimerGame();
                  break;
              }
            });
          });
      }
    },
    async saveNetworkingUsersTeacher() {
      this.userAddedRoom =
        await networkingUsersTeacherServices.createdNetworkingUsersTeacher({
          networkingId: Number(this.$route.params.idNetworking),
        });
      await this.subscribeToTeacherParticipants(
        this.userAddedRoom.networkingTeacher.id,
        this.userAddedRoom.networkingTeacher.aforo
      );
      if (this.userAddedRoom) {
        this.$buefy.toast.open({
          duration: 5000,
          position: "is-bottom",
          message: "¡Ingresando a la sala con éxito!",
          type: "is-success",
        });
        this.createdLiveKit(this.userAddedRoom.networkingTeacher);
      }
    },
    async votePoll(id, response) {
      try {
        if (!this.isPrivateRoom && !this.isUrl) {
          const obj = {
            response,
            considerNetworkingId: id,
          };
          await networkingService.createResponseRoomSurvey(obj);
        } else {
          const objTeacher = {
            response,
            considerNetworkingTeacherId: id,
          };
          await networkingService.createResponseSurveyTeacher(objTeacher);
        }
        this.modalSurveyResponses = false;
      } catch (error) {
        console.log(error);
      }
    },
    async voteQuestion(id, response) {
      try {
        if (!this.isPrivateRoom && !this.isUrl) {
          const obj = {
            response,
            evaluationNetworkingId: id,
          };
          await networkingService.createResponseRoomGame(obj);
        } else {
          const objTeacher = {
            response,
            evaluationNetworkingTeacherId: id,
          };
          await networkingService.createResponseGameTeacher(objTeacher);
        }
        this.modalGameResponses = false;
        this.gameResponses = [];
      } catch (error) {
        console.log(error);
      }
    },
    async privateRoomSurveyResults(id) {
      try {
        this.infoPrivateRoomSurveyResults =
          await networkingService.getResultSurveyTeacher(id);
        this.arrayResultSurvey = JSON.parse(
          this.infoPrivateRoomSurveyResults[0].considerNetworkingTeacher.answers
        );
      } catch (error) {
        console.log(error);
      }
    },
    async privateRoomGameResults(id) {
      try {
        this.infoRoomGameResults = await networkingService.getResultGameTeacher(
          id
        );
      } catch (error) {
        console.log(error);
      }
    },
    async roomSurveyResults(id) {
      try {
        this.infoRoomSurveyResults =
          await networkingService.getResultRoomSurvey(id);
        this.arrayResultSurvey = JSON.parse(
          this.infoRoomSurveyResults[0].considerNetworking.answers
        );
      } catch (error) {
        console.log(error);
      }
    },
    async roomGameResults(id) {
      try {
        this.infoRoomGameResults = await networkingService.getResultRoomGame(
          id
        );
      } catch (error) {
        console.log(error);
      }
    },
    countDownTimer() {
      this.timer = this.surveyInfo.duration;
      let interval = setInterval(() => {
        if (this.timer === 0) {
          clearInterval(interval);
        } else {
          this.timer -= 1000;
          return milisegundosAMinutosYSegundos(this.timer);
        }
      }, 1000);
      const milisegundosAMinutosYSegundos = (milisegundos) => {
        this.minutes = parseInt(milisegundos / 1000 / 60);
        milisegundos -= this.minutes * 60 * 1000;
        this.seconds = milisegundos / 1000;
        if (this.minutes === 0 && this.seconds === 0) {
          this.sectionSurveyresult = true;
          this.sectionSurveyTime = false;
        }
        return `${this.minutes}:${this.seconds}`;
      };
    },
    countDownTimerGame() {
      this.timerGame = this.gameInfo.duration;
      let interval = setInterval(() => {
        if (this.timerGame === 0) {
          clearInterval(interval);
        } else {
          this.timerGame -= 1000;
          return milisegundosAMinutosYSegundos(this.timerGame);
        }
      }, 1000);
      const milisegundosAMinutosYSegundos = (milisegundos) => {
        this.minutesGame = parseInt(milisegundos / 1000 / 60);
        milisegundos -= this.minutesGame * 60 * 1000;
        this.secondsGame = milisegundos / 1000;
        if (this.minutesGame === 0 && this.secondsGame === 0) {
          this.sectionGameResult = true;
          this.sectionGameTime = false;
        }
        return `${this.minutesGame}:${this.secondsGame}`;
      };
    },
    createArrayFeedback() {
      try {
        if (this.gameInfo.responses[0].correct === true) {
          this.arrayCorrectAnswers.push(this.gameInfo.responses[0].question);
        }
        if (this.gameInfo.responses[1].correct === true) {
          this.arrayCorrectAnswers.push(this.gameInfo.responses[1].question);
        }
        if (this.gameInfo.responses[2].correct === true) {
          this.arrayCorrectAnswers.push(this.gameInfo.responses[2].question);
        }
        if (this.gameInfo.responses[3].correct === true) {
          this.arrayCorrectAnswers.push(this.gameInfo.responses[3].question);
        }
      } catch (error) {
        console.error("error", error);
      }
    },
    closeModalFeedback() {
      this.modalGameFeedback = false;
      this.arrayCorrectAnswers = [];
    },
    onLiveKitDisconnected() {
      this.$buefy.toast.open({
        duration: 3000,
        position: "is-bottom",
        message: "Saliste de la sala",
        type: "is-info",
      });
      // Al colgar, el usuario sale de la sala y vuelve al distrito
      if (this.breakoutPollInterval) clearInterval(this.breakoutPollInterval);
      this.$router.push({ name: "Networking" });
    },
    onLiveKitError(error) {
      console.error("[LiveKit] Error:", error);
      this.$buefy.toast.open({
        duration: 5000,
        position: "is-bottom",
        message:
          "Error de conexión con la videollamada. Intenta recargar la página.",
        type: "is-danger",
      });
    },
    onParticipantCountChange(count) {
      this.livekitParticipantCount = count;
      this.changeNumberParticipants();
    },
  },
  beforeDestroy() {
    if (this.unsubscribeUsers) this.unsubscribeUsers();
    if (this.unsubscribeTeacherParticipants)
      this.unsubscribeTeacherParticipants();
    if (this.unsubscribeSurvey) this.unsubscribeSurvey();
    if (this.unsubscribeGame) this.unsubscribeGame();
    if (this.breakoutPollInterval) clearInterval(this.breakoutPollInterval);
  },
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
    roleValidationNoAccess() {
      // Mismos roles bloqueados que en la vista Networking
      return ["University", "AdministratorCall"].some(
        (a) => a === this.role
      );
    },
    // Fecha y hora en que se realizará el networking de la sala
    scheduleLabel() {
      if (!this.networking?.scheduledAt) return "";
      return this.$moment(this.networking.scheduledAt).format(
        "DD/MM/YYYY - hh:mm a"
      );
    },
    // Breakouts y moderación por JWT solo aplican a salas públicas de
    // networking (las privadas de profesor usan otro modelo)
    networkingMode() {
      return !this.isPrivateRoom && !this.isUrl;
    },
    isInBreakout() {
      return Boolean(
        this.currentRoomName &&
          this.livekitRoomName &&
          this.currentRoomName !== this.livekitRoomName
      );
    },
    hasOpenBreakouts() {
      return this.breakouts.length > 0 && this.breakoutStatus === "open";
    },
    // Participantes asignables (excluye al moderador)
    assignableParticipants() {
      return this.networkingUsers.filter(
        (networkingUser) => String(networkingUser.userId) !== String(this.user.id)
      );
    },
    startContinue() {
      if (
        this.correctAnswersOne &&
        this.gameInfo.question &&
        this.gameInfo.answersOne &&
        this.gameInfo.answersTwo &&
        this.gameInfo.duration
      ) {
        return true;
      }
      if (
        this.correctAnswersTwo &&
        this.gameInfo.question &&
        this.gameInfo.answersOne &&
        this.gameInfo.answersTwo &&
        this.gameInfo.duration
      ) {
        return true;
      }
      if (
        this.correctAnswersThree &&
        this.gameInfo.question &&
        this.gameInfo.answersOne &&
        this.gameInfo.answersTwo &&
        this.gameInfo.duration
      ) {
        return true;
      }
      if (
        this.correctAnswersFour &&
        this.gameInfo.question &&
        this.gameInfo.answersOne &&
        this.gameInfo.answersTwo &&
        this.gameInfo.duration
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" src="./Meet.scss" scoped></style>
